module.exports = __webpack_public_path__ + "bb4e529f3998a83266f025064997a21b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-15.png
// module id = 2187
// module chunks = 0